import { Container, Row, Col, Image } from "react-bootstrap";
import "./index.css";
import { BsFacebook, BsTwitter, BsLinkedin, BsInstagram, BsGeoAlt, BsTelephone, BsEnvelope } from "react-icons/bs";
import logo from "../../../assets/logo/on9estate-horizontal-logo.png";

const Footer = () => {
  return (
    <footer className="footer-section">
      <Container>
        <Row className="gy-4">
          <Col md={4}>
            <Image src={logo} height={60} />
            <p className="mt-4">Streamline their operations with a powerful CRM designed for lead management, booking automation, and financial insights.<br /> To make property sales, customer interactions, and financial tracking effortless, so you can focus on growth.</p>
          </Col>

          <Col md={4}>
            <h5 className="fw-bold mb-3">Quick Links</h5>
            <ul className="list-unstyled">
              <li><a href="#about" className="animated-link mb-2">About Us</a></li>
              <li><a href="#features" className="animated-link mb-2">Features</a></li>
              <li><a href="#pricing" className="animated-link mb-2">Pricing</a></li>
              <li><a href="#contact" className="animated-link">Contact</a></li>
            </ul>
          </Col>

          <Col md={4}>
            <h5 className="fw-bold mb-3">Contact Us</h5>
            <div className="d-flex align-items-start justify-content-center justify-content-xl-start text-secondary mb-3">
              <div>
                <BsGeoAlt size={16} className="me-2" />
              </div>
              <div>
                238C/4R, Harwara, Dhoomanganj, Prayagraj,
                <br />
                Uttar Pradesh, 211011
              </div>
            </div>
            <div className="d-flex align-items-start justify-content-center justify-content-xl-start text-secondary mb-3">
              <div>
                <BsTelephone size={16} className="me-2" />
              </div>
              <div>
                +91 7800-111-018
              </div>
            </div>
            <div className="d-flex align-items-start justify-content-center justify-content-xl-start text-secondary">
              <div>
                <BsEnvelope size={16} className="me-2" />
              </div>
              <div>
                support@on9estate.com
              </div>
            </div>
          </Col>
        </Row>

        <Row className="mt-4 border-top py-3">
          <Col md={6}>
            <div className="text-start d-flex align-items-center justify-content-center justify-content-xl-start h-100">
              <a href="#" className="text-dark social-icon me-4"><BsFacebook size={20} /></a>
              <a href="#" className="text-dark social-icon me-4"><BsTwitter size={20} /></a>
              <a href="#" className="text-dark social-icon me-4"><BsLinkedin size={20} /></a>
              <a href="#" className="text-dark social-icon"><BsInstagram size={20} /></a>
            </div>
          </Col>
          <Col md={6}>
            <p className="mt-3 text-xl-end text-center">&copy; {new Date().getFullYear()} On9Estate | Powered By <a href="https://www.appzito.com" target="_blank" className="text-dark fw-600 appzito-link">Appzito Technologies</a>. All rights reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;